// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TOnS","content":"styles_content__eFMKP"};